import React from 'react';

import {
  ArticleChecklist,
  ArticleEyebrow,
  ArticleHero,
  ArticleList,
  ArticleSection,
  ArticleShell,
  ArticleTable,
  ArticleTag,
  ArticleTagRow,
} from '../../articleStyles';
import { useHelpCenterLocale } from '../../localization';
import { HelpCenterContentDefinition } from '../../types';
import translations from './translations';

export const VISIT_SCHEDULE_CSV_GUIDE_SLUG = 'visit-schedule-csv-guide';

const Content: React.FC<{ mode: 'page' | 'modal' }> = ({ mode }) => {
  const t = useHelpCenterLocale(translations);

  return (
    <ArticleShell mode={mode}>
      <ArticleHero compact={mode === 'modal'}>
        <ArticleEyebrow>{t.category}</ArticleEyebrow>
        <h1>{t.title}</h1>
        <p>{t.hero}</p>
        <ArticleTagRow>
          {t.tags.map((tag) => (
            <ArticleTag key={tag}>{tag}</ArticleTag>
          ))}
        </ArticleTagRow>
      </ArticleHero>

      <ArticleSection>
        <h3>{t.generalRulesTitle}</h3>
        <ArticleChecklist>
          <li>{t.generalRulesItem1}</li>
          <li>{t.generalRulesItem2}</li>
          <li>{t.generalRulesItem3}</li>
          <li>{t.generalRulesItem4}</li>
          <li>{t.generalRulesItem5}</li>
          <li>{t.generalRulesItem6}</li>
        </ArticleChecklist>
      </ArticleSection>

      <ArticleSection>
        <h3>{t.fieldsTitle}</h3>
        <ArticleList>
          <li>{t.fieldsItem1}</li>
          <li>{t.fieldsItem2}</li>
          <li>
            {t.fieldsItem3}
            <ArticleTable>
              <thead>
                <tr>
                  <th>{t.periodicityTableHeader1}</th>
                  <th>{t.periodicityTableHeader2}</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>1</td><td>{t.periodicityDaily}</td></tr>
                <tr><td>2</td><td>{t.periodicityWeekly}</td></tr>
                <tr><td>3</td><td>{t.periodicityBiweekly}</td></tr>
                <tr><td>4</td><td>{t.periodicityMonthly}</td></tr>
              </tbody>
            </ArticleTable>
          </li>
          <li>
            {t.fieldsItem4}
            <ArticleTable>
              <thead>
                <tr>
                  <th>{t.weekdayTableHeader}</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>{t.weekdayMonday}</td></tr>
                <tr><td>{t.weekdayTuesday}</td></tr>
                <tr><td>{t.weekdayWednesday}</td></tr>
                <tr><td>{t.weekdayThursday}</td></tr>
                <tr><td>{t.weekdayFriday}</td></tr>
                <tr><td>{t.weekdaySaturday}</td></tr>
                <tr><td>{t.weekdaySunday}</td></tr>
              </tbody>
            </ArticleTable>
          </li>
          <li>{t.fieldsItem5}</li>
          <li>{t.fieldsItem6}</li>
        </ArticleList>
      </ArticleSection>
    </ArticleShell>
  );
};

const visitRoutinesCsvGuide: HelpCenterContentDefinition = {
  id: 'visit-schedule-csv-guide',
  slug: VISIT_SCHEDULE_CSV_GUIDE_SLUG,
  meta: translations,
  keywords: {
    en: ['visit_routines', 'visita_agendamento', 'visit routines', 'csv', 'fastmanager'],
    pt: ['visit_routines', 'visita_agendamento', 'rotinas de visitas', 'csv', 'fastmanager'],
  },
  order: 2,
  visibility: {
    type: 'permission',
    permission: 'databaseManagement-tables-list',
  },
  allowedDisplayModes: ['page', 'modal'],
  Content,
};

export default visitRoutinesCsvGuide;
